import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgInformationCircle(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.8 9.79961C13.8 8.58458 14.785 7.59961 16 7.59961C17.215 7.59961 18.2 8.58458 18.2 9.79961C18.2 11.0146 17.215 11.9996 16 11.9996C14.785 11.9996 13.8 11.0146 13.8 9.79961Z"
      />
      <path fill="currentColor" d="M14.4999 14.3996H17.4999V24.3996H14.4999V14.3996Z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0.75C7.57766 0.75 0.75 7.57766 0.75 16C0.75 24.4223 7.57766 31.25 16 31.25C24.4223 31.25 31.25 24.4223 31.25 16C31.25 7.57766 24.4223 0.75 16 0.75ZM3.25 16C3.25 8.95837 8.95837 3.25 16 3.25C23.0416 3.25 28.75 8.95837 28.75 16C28.75 23.0416 23.0416 28.75 16 28.75C8.95837 28.75 3.25 23.0416 3.25 16Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInformationCircle);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
